<script lang="ts" setup>
import { buildMeta } from "~~/utils/meta-builder";

interface Entry {
    title: string
    company: string
    body: string
    action: string
    link: string
}

const i18n = useI18n();
const localePath = useLocalePath()

const config = useRuntimeConfig()
const emails = config.public.email;
const email = `<a class="text-link hover:text-white" href="mailto:${emails.other}">${emails.other}</a>`
const privacyEmail = `<a class="text-link hover:text-white" href="mailto:${emails.privacy}">${emails.privacy}</a>`

const tmp =  <any>i18n.tm('privacy.processing.entries')
const entries = <Entry[]>tmp.map((it: any)=><Entry>{
    title: i18n.rt(it.title),
    company: i18n.rt(it.company),
    body: i18n.rt(it.body),
    action: i18n.rt(it.action),
    link: i18n.rt(it.link),
})

useHead(buildMeta({ key:'privacy',  follow: true }))

const list = computed(() => {
    return entries
})
//i18n.mergeLocaleMessage('en', termsEn);
//i18n.mergeLocaleMessage('de', termsDe);


</script>
<template>
    <div class="bg-primary-500">
        <Header theme="dark" />
        <div class="container main md:max-w-screen-md mx-auto text-white px-6 md:px-0">  
            <div class="text-white py-20">
                <h1 class="font-bold text-3xl md:text-4xl font-owners">{{$t('privacy.title')}}</h1>
                <p class="text-2xl py-4 font-light text-white/75">{{$t('privacy.body')}}</p>
              
                <p class="text-lg pt-10 font-light text-white/75">{{$t('privacy.date')}}</p>
                <p class="text-2xl py-4 font-light text-white/75">{{$t('privacy.note')}}</p>
            </div>
        
            <div class="content-section" >
                <img src="@/assets/privacy_safe_data.svg" width="60" height="56" alt="privacy" class="mb-5 w-28 mx-auto" />  
                <div class="content-body">
                    <h3 class="font-owners font-bold text-2xl pb-2 text-white">{{$t('privacy.data_safety.title')}}</h3>
                    {{$t('privacy.data_safety.body')}}
                </div>
            </div>
            <div class="content-section" >
                <img src="@/assets/privacy_data_control.svg" width="60" height="56" alt="privacy" class="mb-5 w-28 mx-auto" />  
                <div class="content-body">
                    <h3 class="font-owners font-bold text-2xl pb-2 text-white">{{$t('privacy.data_control.title')}}</h3>
                    {{$t('privacy.data_control.body')}}
                </div>
            </div>
            <div class="content-section" >
                <img src="@/assets/privacy_data_transfare.svg" width="60" height="56" alt="privacy" class="mb-5 w-28 mx-auto" />  
                <div class="content-body">
                    <h3 class="font-owners font-bold text-2xl pb-2 text-white">{{$t('privacy.data_transfer.title')}}</h3>
                    {{$t('privacy.data_transfer.body')}}
                </div>
            </div>
            <div class="content-section" >
                <img src="@/assets/privacy_accept.svg" width="60" height="56" alt="privacy" class="mb-5 w-24 mx-auto" />  
                <div class="content-body">
                    <h3 class="font-owners font-bold text-2xl pb-2 text-white">{{$t('privacy.attention.title')}}</h3>
                    {{$t('privacy.attention.body')}}
                </div>
            </div>
            <div class="content-section" >
                <img src="@/assets/privacy_support.svg" width="60" height="56" alt="privacy" class="mb-5 w-28 mx-auto" />  
                <div class="content-body">
                    <h3 class="font-owners font-bold text-2xl pb-2 text-white">{{$t('privacy.question.title')}}</h3>
                    <p v-html="$t('privacy.question.body',  {'email': email})"></p>
                </div>
            </div>

       
            <div class="content-section" >
                <div class="content-sticky-section">
                   <h3 class="headline">{{$t('privacy.collect.title')}}</h3>
                </div>
                <div class="content-body">
                    <p class="pb-10 text-xl">{{$t('privacy.collect.body')}}</p>
                    <ul class="list-disc ml-2">
                        <li v-for="item of $tm('privacy.collect.mandatory')">{{$rt(item as any)}}</li>
                    </ul>
                    <p class="py-10">{{$t('privacy.collect.optional')}}</p>
                    <h3 class="font-bold font-owners text-white text-lg">{{$t('privacy.collect.buddies.title')}}</h3>
                    <p class="pt-2">{{$t('privacy.collect.buddies.body')}}</p>
                    <h2 class="pt-10 font-owners text-white/70 text-xl">{{$t('privacy.collect.default.title')}}</h2>
                    <h3 class="pt-6 pb-2 font-bold font-owners text-white text-lg">{{$t('privacy.collect.default.location.title')}}</h3>
                    <ul class="list-disc ml-2">
                        <li v-for="item of $tm('privacy.collect.default.location.entries')">{{$rt(item as any)}}</li>
                    </ul>

                    <h3 class="pt-6 pb-2 font-bold font-owners text-white text-lg">{{$t('privacy.collect.default.device_info.title')}}</h3>
                    <ul class="list-disc ml-2">
                        <li v-for="item of $tm('privacy.collect.default.device_info.entries')">{{$rt(item as any)}}</li>
                    </ul>

                    <h3 class="pt-6 pb-2 font-bold font-owners text-white text-lg">{{$t('privacy.collect.default.app_using.title')}}</h3>
                    <ul class="list-disc ml-2">
                        <li v-for="item of $tm('privacy.collect.default.app_using.entries')">{{$rt(item as any)}}</li>
                    </ul>
                </div>
            </div>


            <div class="content-section" >
                <div class="content-sticky-section">
                   <h3 class="headline">{{$t('privacy.using.title')}}</h3>
                </div>
                <div class="content-body">
                    <p class="pb-10 text-xl">{{$t('privacy.using.body')}}</p>
                    <ul class="list-disc ml-2">
                        <li v-for="item of $tm('privacy.using.entries')">{{$rt(item as any)}}</li>
                    </ul>
                </div>
            </div>

            <div class="content-section" >
                <div class="content-sticky-section">
                    <h3 class="headline">{{$t('privacy.community.title')}}</h3>
                </div>
                <div class="content-body">
                    <p class="pb-10 text-xl">{{$t('privacy.community.body')}}</p>
                    <ul class="list-disc ml-2">
                        <li v-for="item of $tm('privacy.community.points')" :key="$rt(item as any)">
                            {{$rt(item as any)}}
                        </li>
                    </ul>
                    <p class="pt-6">
                    <NuxtLink :to="localePath('/privacy-community')" class="text-amber-400 underline">
                        {{$t('privacy.community.moreLink')}}
                    </NuxtLink>
                    </p>
                </div>
            </div>

             <div class="content-section" >
                <div class="content-sticky-section">
                   <h3 class="headline">{{$t('privacy.share.title')}}</h3>
                </div>
                <div class="content-body">
                    <p class="pb-10 text-xl">{{$t('privacy.share.body')}}</p>
                </div>
            </div>

            <div class="content-section" >
                <div class="content-sticky-section">
                   <h3 class="headline">{{$t('privacy.consent.title')}}</h3>
                </div>
                <div class="content-body">
                    <p class="pb-10 text-xl">{{$t('privacy.consent.body')}}</p>
                </div>
            </div>

            <div class="content-section" >
                <div class="content-sticky-section">
                   <h3 class="headline">{{$t('privacy.storage.title')}}</h3>
                </div>
                <div class="content-body">
                    <p class="pb-10 text-xl">{{$t('privacy.storage.body')}}</p>
                </div>
            </div>

            <div class="content-section" >
                <div class="content-sticky-section">
                   <h3 class="headline">{{$t('privacy.clear.title')}}</h3>
                </div>
                <div class="content-body">
                    <p class="pb-10 text-xl">{{$t('privacy.clear.body')}}</p>
                </div>
            </div>

            <div class="content-section" >
                <div class="content-sticky-section">
                   <h3 class="headline">{{$t('privacy.processing.title')}}</h3>
                </div>
                <div class="content-body">
                    <div class="" v-for="it of list">
                        <h5 class="text-lg font-bold text-white">{{it.title}}</h5>
                        <p class="text-md pb-2">{{it.company}}</p>
                        <a class="text-amber-400" target="_blank" :href="it.link">{{it.action}}</a>
                        <p class="text-sm py-6" v-html="it.body"></p>
                    </div>
                </div>
            </div>

            <div class="content-section" >
                <div class="content-sticky-section">
                   <h3 class="headline">{{$t('privacy.contact.title')}}</h3>
                </div>
                <div class="content-body">
                    <p class="pb-10 text-xl" v-html="$t('privacy.contact.body', {'privacy_email': privacyEmail})"></p>
                </div>
            </div>


            

         
        </div> 
				<div class="bg-white">
					<Footer />
				</div>
    </div>
</template>

